window.addEventListener('DOMContentLoaded', function () {


    let date = new Date();
    let timerExpireCountDays = 8 - date.getDay();
    date.setDate(date.getDate() + timerExpireCountDays);
    date.setHours(0,0,0,0);
    const deadline = date;

	function getTimeRemaining(endtime) {
		const t = Date.parse(endtime) - Date.parse(new Date()),
			days = Math.floor((t / (1000 * 60 * 60 * 24))),
			seconds = Math.floor((t / 1000) % 60),
			minutes = Math.floor((t / 1000 / 60) % 60),
			hours = Math.floor((t / (1000 * 60 * 60) % 24));

		return {
			'total': t,
			'days': days,
			'hours': hours,
			'minutes': minutes,
			'seconds': seconds
		};
	}

	function getZero(num) {
		if ( num < 10) {
			return '0' + num;
		} else {
			return num;
		}
	}

	function setClock(selector, endtime) {

		const timer = document.querySelector(selector);

        if (!timer || 'undefined' === typeof(timer))
            return;

        const
			timerItem = timer.querySelectorAll(".timer__item"),
			timerField = timer.querySelectorAll("span"),
			days = timer.querySelector('#days'),
			hours = timer.querySelector('#hours'),
			minutes = timer.querySelector('#minutes'),
			seconds = timer.querySelector('#seconds'),
			daysNew = timer.querySelector('#days-new'),
			hoursNew = timer.querySelector('#hours-new'),
			minutesNew = timer.querySelector('#minutes-new'),
			secondsNew = timer.querySelector('#seconds-new'),
			timeInterval = setInterval(updateClock, 1000);

		updateClock();

		function updateClock() {
			const t = getTimeRemaining(endtime);

			let daysValue = getZero(t.days),
				daysFirstDigit = (daysValue - (daysValue % 10)) / 10,
				daysSecondDigit = daysValue % 10,

				hoursValue = getZero(t.hours),
				hoursFirstDigit = (hoursValue - (hoursValue % 10)) / 10,
				hoursSecondDigit = hoursValue % 10,

				minutesValue = getZero(t.minutes),
				minutesFirstDigit = (minutesValue - (minutesValue % 10)) / 10,
				minutesSecondDigit = minutesValue % 10,

				secondsValue = getZero(t.seconds),
				secondsFirstDigit = (secondsValue - (secondsValue % 10)) / 10,
				secondsSecondDigit = secondsValue % 10;

			daysNew.querySelectorAll('span')[0].textContent = daysFirstDigit;
			daysNew.querySelectorAll('span')[1].textContent = daysSecondDigit;

			hoursNew.querySelectorAll('span')[0].textContent = hoursFirstDigit;
			hoursNew.querySelectorAll('span')[1].textContent = hoursSecondDigit;

			minutesNew.querySelectorAll('span')[0].textContent = minutesFirstDigit;
			minutesNew.querySelectorAll('span')[1].textContent = minutesSecondDigit;

			secondsNew.querySelectorAll('span')[0].textContent = secondsFirstDigit;
			secondsNew.querySelectorAll('span')[1].textContent = secondsSecondDigit;

			timerItem.forEach( item => {
				let itemOld = item.querySelectorAll(".timer__num span"),
					itemNew = item.querySelectorAll(".timer__new span"),

					itemOldFirst = itemOld[0].textContent,
					itemOldSecond = itemOld[1].textContent,

					itemNewFirst = itemNew[0].textContent,
					itemNewSecond = itemNew[1].textContent;

				function animateNum(num) {
					itemOld[num].style.animation = "0.7s downTopNum, 0s upTopNum 0.7s";
					itemNew[num].style.animation = "0.7s downBottomNum, 0s upBottomNum 0.7s";
				};

				if ( itemOldFirst !== itemNewFirst ) {
					itemOld[0].textContent = itemNewFirst;
					animateNum(0);
				} else {
					itemOld[0].textContent = itemNewFirst;
				};

				if (itemOldSecond !== itemNewSecond ) {
					itemOld[1].textContent = itemNewSecond;
					animateNum(1);
				} else {
					itemOld[1].textContent = itemNewSecond;
				}
			});

			setTimeout ( function() {
				timerField.forEach( item => {
					item.style.animation = "none";
				});
			}, 700);

			if (t.total <= 0) {
				days.querySelectorAll('span')[0].textContent = "0";
				days.querySelectorAll('span')[1].textContent = "0";

				hours.querySelectorAll('span')[0].textContent = "0";
				hours.querySelectorAll('span')[1].textContent = "0";

				minutes.querySelectorAll('span')[0].textContent = "0";
				minutes.querySelectorAll('span')[1].textContent = "0";

				seconds.querySelectorAll('span')[0].textContent = "0";
				seconds.querySelectorAll('span')[1].textContent = "0";

				daysNew.querySelectorAll('span')[0].textContent = "0";
				daysNew.querySelectorAll('span')[1].textContent = "0";

				hoursNew.querySelectorAll('span')[0].textContent = "0";
				hoursNew.querySelectorAll('span')[1].textContent = "0";

				minutesNew.querySelectorAll('span')[0].textContent = "0";
				minutesNew.querySelectorAll('span')[1].textContent = "0";

				secondsNew.querySelectorAll('span')[0].textContent = "0";
				secondsNew.querySelectorAll('span')[1].textContent = "0";

				clearInterval(timeInterval);
			}
		}
	}

	setClock('.timer', deadline);
});
